export function buildJurisdictionsTableModel(dtoRows) {
  return dtoRows.map((item) => ({
    id: item.id,
    name: item.name,
    byDefault: Boolean(item.byDefault),
    countries: Array.isArray(item.countries) ? item.countries : [],
  }));
}

export function buildEmptyJurisdictionForm() {
  return {
    name: '',
    byDefault: false,
    countries: [],
  };
}

